<template>
  <div class="notice-item" @click="itemClick" @mouseenter="mouseenter" @mouseleave="editShow = false">
    <div class="edit" v-show="editShow">
      <el-button @click.stop="deleteClick" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
    </div>
    <el-image :src="imgList[0]" class="img" fit="contain">
      <div slot="error" class="image-slot" style="
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f7fa;
          color: #c0c4cc;
        ">
        <div>无图片</div>
      </div>
    </el-image>
    <div class="item-content">
      <div class="title">{{ item.title }}</div>
      <div class="content" v-html="item.content"></div>
      <div class="bottom">
        <div>
          <span class="iconfont icon-time"></span>
          {{ item.publicTime }}
          {{ item.status == 1 ? "已发布" : '未发布' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noticeStatusList: {
      type: Array,
      default: () => {
        return [];
      },
    }
  },
  data() {
    return {
      imgList: [],
      editShow: false, // 是否显示删除按钮 管理员始终显示 教师根据发布id判断是否显示
    };
  },
  created() {
    if (this.item.imgList && this.item.imgList.length) {
      this.imgList = this.item.imgList.split(",");
    } else {
      this.imgList = [
        "https://vkceyugu.cdn.bspapp.com/VKCEYUGU-19c36953-4507-47ea-9579-c9d9093ec61e/8fa47bd3-263f-4a0e-ae64-952c46fdb1f3.png",
      ];
    }
  },
  methods: {
    itemClick() {
      this.$router.push({
        path: "/notice-detail",
        query: {
          id: this.item.id,
        },
      });
    },
    mouseenter() {
      this.editShow = this.user.roleId == 1 || this.user.id == this.item.createBy;
    },
    deleteClick() {
      this.$confirm("是否删除该公告?", "删除公告", {
        confirmButtonText: "确定",
        cancelButtomText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.$emit("deleteClick", {
            id: this.item.id,
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./notice-item";
</style>
